var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showLayout)?_c('PageLayout',{staticClass:"managers-page"},[_c('Managers')],1):_c('Managers')}
var staticRenderFns = []

export { render, staticRenderFns }